module.exports = __webpack_public_path__ + "img/missionaustralia.75be8c2.png";